import { styled } from '@mui/system';
import SvgIcon from '@mui/material/SvgIcon';

export const StyledSvgIcon = styled(SvgIcon, {
  shouldForwardProp: prop => !['isActive', 'isCompleted'].includes(prop)
})(({ theme, isActive, isCompleted }) => ({
  stroke: theme.palette.grey[300],
  strokeWidth: 2,
  ...(isActive && {
    stroke: theme.palette.primary.main
  }),
  ...(isCompleted && {
    stroke: theme.palette.secondary.main
  })
}));

export const textStyle = theme => ({
  fill: theme.palette.common.black,
  fontSize: '0.75rem',
  strokeWidth: 0
});

export const checkMarkStyle = theme => ({
  fill: theme.palette.getContrastText(theme.palette.common.black),
  strokeWidth: 0
});
